import React from "react";
import "./styles.css";
import Lectures from "./lectures";




export default function App() {
  return (
    <div className="App">
      <Lectures />
    </div>
  );
}
